import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const AddressSecondary = ({ ...props }: InputComponentProps) => (
  <ValidatingInput
    label="Apartment, suite, etc."
    name="addressSecondary"
    optional
    validate={() => true}
    {...props}
  />
);
